__turbopack_context__.v({
  "charNica": "miUeKG_charNica",
  "classNumber": "miUeKG_classNumber",
  "container": "miUeKG_container",
  "iconCheck": "miUeKG_iconCheck",
  "iconWrap": "miUeKG_iconWrap",
  "isSelected": "miUeKG_isSelected",
  "left": "miUeKG_left",
});
